import { deleteExclusionAreas } from './deleteExclusionAreas'
import { getExclusionAreasByFarm } from './getExclusionAreas'

export const exclusionAreas = {
  getExclusionAreasByFarm,
  deleteExclusionAreas,
}
